const Skills = () => {
  return (
    <section className="skills">
      <div className="skills-inner">
        <div className="skills-heading">
          <h2>Skills</h2>
        </div>
      </div>
    </section>
  );
};
export default Skills;
